import { TRACKERS } from "@/constants/Trackers";
import { FileDetail } from "@/features/Patient/MedicalRecords/Files/FileDetail/FileDetail";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/files/$fileId")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_FILES);
  },
});

function RouteComponent() {
  return <FileDetail />;
}
